// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

export enum FieldKind {
  Unsigned = 0,
  Signed = 1,
  Bool = 2,
  Bytes = 3,
}
